// extracted by mini-css-extract-plugin
export default {"Person":"Person_Person__98nIu","team":"Person_team__GYgrk","Pronouns":"Person_Pronouns__uppfT"};